import { PropsWithChildren, useEffect } from "react";
import Modal from "react-modal";
import { Icon } from "assets/icons";
import { useSetAtom, WritableAtom } from "jotai";
import { setModalCloseAtom } from "atoms/modalAtom/modalAtom";

import { BoldText } from "components/BoldText/BoldText";

import styles from "./styles.module.scss";

Modal.setAppElement("#root");

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    overflow: "scroll",
    width: "auto",
    height: "auto",
    maxWidth: "90vw",
    maxHeight: "90vh",
    padding: "0",
    // borderRadius: "8px",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    backdropFilter: "blur(3px)",
  },
};

type ModalProps = {
  isOpen: boolean;
};

type ModalHeaderProps = {
  title: string;
  onClose?: () => void;
  modalCloseAtom?: WritableAtom<unknown, [], any>;
};

export const ModalHeader = ({
  title,
  onClose,
  modalCloseAtom = setModalCloseAtom,
}: ModalHeaderProps): JSX.Element => {
  const closeModal = useSetAtom(modalCloseAtom!);

  return (
    <div className="flex justify-between items-center">
      <BoldText>{title}</BoldText>
      <Icon
        type="close"
        onClick={onClose || closeModal}
        className="cursor-pointer"
      />
    </div>
  );
};

export const AppModal = (props: PropsWithChildren<ModalProps>): JSX.Element => {
  const { isOpen } = props;

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      style={customStyles}
      portalClassName="modal"
      className={styles.modalContent}
    >
      {props.children}
    </Modal>
  );
};
